module.exports = __webpack_public_path__ + "static/media/logo-interbank-w.50a4e220.png";